var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paymentError"},[_c('div',{staticClass:"pay_title"},[_c('van-icon',{staticClass:"icon",attrs:{"name":"cross"}}),_c('div',[_vm._v(_vm._s(_vm.productName))]),_c('div',[_vm._v("购买失败")])],1),_c('div',{staticClass:"pay_content"},[_vm._v("请联系客服")])])
}
var staticRenderFns = []

export { render, staticRenderFns }